import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { SvgIcon } from '@material-ui/core';
import { KeyNew as KeyIcon } from '../../../components/Icons';
import Button from '../../../components/Basic/Button';
import { colorPrimary, colorSafe } from '../../../material-ui-theme';
import { useSelector } from 'react-redux';
import { getIsBrokers } from '../../../reducers';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    paddingLeft: 8,
    paddingRight: 8,

    '& button': {
      height: 35,
      color: 'var(--color-colorPrimary-main)',
      border: '1px solid',
      borderColor: colorPrimary.light,
      backgroundColor: 'var(--color-backgroundColors-hoverRowAlt)',
      display: 'flex',
      alignItems: 'center',
      lineHeight: 0,
      paddingTop: 0,
      paddingBottom: 0,

      '&:hover': {
        backgroundColor: 'var(--color-backgroundColors-hoverRowAlt)',
      },

      '& .key-icon': {
        fontSize: 18,
        transform: 'rotate(-40deg)',
      },

      '&.mini': {
        padding: 0,
        minWidth: 'initial',
        width: 35,
      },
    },

    '&.login-status': {
      '&--login': {
        '& .key-icon': {
          color: colorSafe.main,
        },
      },

      '&--no-login': {
        '& .key-icon': {
          color: '#FF9B15',
        },
      },
    },
  },
}));

const MiniBrokerLoginKey = () => {
  const classes = useStyles();
  const history = useHistory();
  const brokersData = useSelector(getIsBrokers) || [];
  const loggedInBrokers = brokersData.filter((item) => item.loggedIn);

  const redirectToBrokerLoginKey = () => {
    history.push('/broker-login');
  };

  return (
    <div
      className={`${classes.root} login-status--${
        brokersData.length && brokersData.length === loggedInBrokers.length
          ? 'login'
          : 'no-login'
      }`}
    >
      {brokersData.length > 1 ? (
        <Button
          variant="contained"
          color="primary"
          disableElevation
          startIcon={<SvgIcon component={KeyIcon} className="key-icon" />}
          onClick={redirectToBrokerLoginKey}
        >
          ({loggedInBrokers.length}/{brokersData.length})
        </Button>
      ) : (
        <Button
          variant="contained"
          color="primary"
          disableElevation
          onClick={redirectToBrokerLoginKey}
          className="mini"
        >
          <SvgIcon component={KeyIcon} className="key-icon" />
        </Button>
      )}
    </div>
  );
};

export default MiniBrokerLoginKey;
